import React from "react";
import {LoadingOutlined} from "@ant-design/icons";
import classnames from "classnames";

const LoadingIcon = ({ className, tag }) => {
  const componentClass = 'loadingIcon';
  const classes = classnames(componentClass, className);
  const Wrapper = tag || 'span';

  return <Wrapper className={classes}>
    <LoadingOutlined />
  </Wrapper>;
}
export default LoadingIcon;
